import React from "react";
import { base44 } from "@/lib/api";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import { motion } from "framer-motion";

export default function Areas() {
  const { data: areas = [], isLoading } = useQuery({
    queryKey: ["area-pages-all"],
    queryFn: () => base44.entities.AreaPages.list("city"),
    initialData: [],
  });

  return (
    <div className="min-h-screen bg-background">
      <section className="bg-primary py-24 px-4">
        <div className="max-w-7xl mx-auto">
          <p className="font-body text-accent text-sm font-semibold uppercase tracking-[0.18em] mb-4">Where We Work</p>
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-white max-w-2xl leading-tight">
            Service Areas in Greater Baltimore
          </h1>
          <p className="font-body text-white/65 mt-4 max-w-xl text-lg">
            Based in Dundalk — licensed and serving a 20-mile radius across Baltimore County, Baltimore City, and beyond.
          </p>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {isLoading ? (
          <div className="flex justify-center py-20">
            <div className="w-8 h-8 border-4 border-muted border-t-accent rounded-full animate-spin" />
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
            {areas.map((area, i) => (
              <motion.div
                key={area.id}
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.04 }}
              >
                <Link
                  to={`/areas/${area.slug}`}
                  className="group block bg-card p-6 rounded-xl border border-border hover:border-accent/40 hover:shadow-md transition-all"
                >
                  <div className="flex items-center gap-2 mb-3">
                    <MapPin className="w-4 h-4 text-accent" />
                    <span className="font-body text-xs text-muted-foreground uppercase tracking-wide">Maryland</span>
                  </div>
                  <h2 className="font-heading text-xl font-bold text-foreground mb-2 group-hover:text-accent transition-colors">
                    {area.city}
                  </h2>
                  <p className="font-body text-sm text-muted-foreground line-clamp-2 mb-4">
                    {area.intro}
                  </p>
                  <span className="inline-flex items-center gap-1 font-body text-xs font-semibold text-accent">
                    View Area <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-1 transition-transform" />
                  </span>
                </Link>
              </motion.div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}